import * as React from 'react';
import SVGInline from 'react-svg-inline';
import * as classnames from 'classnames/bind';

import styles from './Export.scss';
import { ExportLocale } from './export.locale';
import arrow from '../../Icon/triangle-arrow.svg';

const cx = classnames.bind(styles);

interface ExportProps {
  locale: ExportLocale;
  isDropDownOpen: boolean;
  toggleDropDown: () => void;
  openDropDown: () => void;
  closeDropDown: () => void;
  exportNetworks: (type: 'json' | 'tsv') => void;
  containerRef: (el: HTMLDivElement | null) => void;
}

const Export: React.SFC<ExportProps> = ({
  locale,
  isDropDownOpen,
  toggleDropDown,
  openDropDown,
  closeDropDown,
  exportNetworks,
  containerRef,
}) => (
  <div className={cx('container', { isOpen: isDropDownOpen })} ref={containerRef}>
    <div className={styles.button} onClick={() => toggleDropDown()}>
      {locale.buttonText}
      <SVGInline svg={arrow} className="d-flex" />
    </div>
    <div className={styles.dropDown}>
      <button
        type="button"
        className={styles.dropDownButton}
        onClick={() => exportNetworks('json')}
        onFocus={() => openDropDown()}
        onBlur={() => closeDropDown()}
      >
        JSON
      </button>
      <div className={styles.delimiter} />
      <button
        type="button"
        className={styles.dropDownButton}
        onClick={() => exportNetworks('tsv')}
        onFocus={() => openDropDown()}
        onBlur={() => closeDropDown()}
      >
        TSV
      </button>
    </div>
  </div>
);

export default Export;



// WEBPACK FOOTER //
// /www/client/src/components/NetworksPage/Export/Export.tsx